import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';

export interface H3Props extends HTMLAttributes<HTMLHeadingElement> {}

const H3 = forwardRef<HTMLHeadingElement, H3Props>(
  ({ className, children, ...props }, ref) => {
    return (
      <h3
        ref={ref}
        className={cn(
          'scroll-m-20 text-2xl font-semibold tracking-tight',
          className
        )}
        {...props}
      >
        {children}
      </h3>
    );
  }
);

H3.displayName = 'H3';

export { H3 };
